import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { BulkUpdateLinksComponent } from './modules/ude-admin/bulk-update-links/bulk-update-links.component';
import { UserResolver } from './resolver/user.resolver';
const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full', resolve: { user: UserResolver } },
  {
    path: 'home',
    loadChildren: () =>
      import('./modules/home/home.module').then((m) => m.HomeModule),
    title: 'Home',
  },
  {
    path: 'brand',
    loadChildren: () => import('./modules/brand/brand.module').then(m => m.BrandModule),
    title: 'Brand Selection'
  },
  {
    path: 'logout',
    loadChildren: () => import('../app/modules/logout/logout.module').then(m => m.LogoutModule),
    title: 'Logged Out'
  },
  {
    path: 'super-admin',
    loadChildren: () => import('./modules/super-admin/super-admin.module').then(m => m.SuperAdminModule),
    title: 'Admin',
    canActivate: [AuthGuard],
    data: {
      roles:  ['ADMIN'], //'USER'
    }
  },
  {
    path: 'ude-admin',
    loadChildren: () => import('./modules/ude-admin/ude-admin.module').then(m => m.UdeAdminModule),
    title: 'Admin',
    canActivate: [AuthGuard],
    data: {
      roles:  ['ADMIN'], //'USER'
    }
  },
  
  { path: 'bulk-update', component: BulkUpdateLinksComponent, title: 'Bulk-Update',
    canActivate: [AuthGuard],
    data: {
      roles:  ['ADMIN'], //'USER'
    }
   },
  {
    path: 'unauthorized',
    loadChildren: () => import('./modules/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule),
    title: 'Unauthorized Access..!!'
  },
  {
    path: 'service-unavailable',
    loadChildren: () => import('./modules/service-unavailable/service-unavailable.module').then(m => m.ServiceUnavailableModule),
    title: 'Service Unavailable..!!'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }